import { OnInit, EventEmitter } from '@angular/core';
import { ModalDialogComponent } from '../../../../shared/components/modal-dialog/modal-dialog.component';
import { ScheduleItem } from '../room-schedule-item/room-schedule-item.component';
import { TranslateService } from '@ngx-translate/core';
import { AllocationTableModel } from './room-allocation-desktop.component';
import { ResourceType, ResourceTypeHelper } from 'src/app/shared/models/resource-type';
var RoomAllocationTableComponent = /** @class */ (function () {
    function RoomAllocationTableComponent(translate) {
        this.translate = translate;
        /**
         * Event raised on click on "create new"
         *
         * @memberof RoomScheduleItemComponent
         */
        this.createReservation = new EventEmitter();
        /**
         * Event raised on click on "open room schedule"
         *
         * @memberof RoomAllocationTableComponent
         */
        this.openSchedule = new EventEmitter();
        /**
         * Event raised on click on day navigation buttons (<,>)
         * If argument is TRUE, navigation schould go backwards
         *
         * @memberof RoomAllocationTableComponent
         */
        this.navigateDate = new EventEmitter();
    }
    Object.defineProperty(RoomAllocationTableComponent.prototype, "model", {
        get: function () {
            return this._model;
        },
        set: function (value) {
            this._model = value;
            this.InitClickeables();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoomAllocationTableComponent.prototype, "currentDate", {
        get: function () {
            return this._currentDate;
        },
        /**
         * Currently selected date of calendar
         *
         * @type {Date}
         * @memberof RoomAllocationTableComponent
         */
        set: function (value) {
            this._currentDate = value;
            this.InitClickeables();
        },
        enumerable: true,
        configurable: true
    });
    RoomAllocationTableComponent.prototype.onResize = function (event) {
        this.innerWidth = window.innerWidth;
    };
    RoomAllocationTableComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.type === undefined) {
            throw new Error("prop '" + nameof('type') + "' must be defined on RoomAllocationTableComponent");
        }
        this.translate.get(ResourceTypeHelper.getString(this.type).toUpperCase() + '_INFORMATION')
            .subscribe(function (text) { return _this.modalRoomInfoTitle = text; });
        this.translate.get('OPEN_' + ResourceTypeHelper.getString(this.type).toUpperCase() + '_INFORMATION')
            .subscribe(function (text) { return _this.openResourceInfoText = text; });
        this.translate.get('OPEN_' + ResourceTypeHelper.getString(this.type).toUpperCase() + '_CALENDAR')
            .subscribe(function (text) { return _this.openResourceCalendarText = text; });
        this.timeStream = [6, 9, 12, 15, 18, 21];
        this.currentDate = new Date(this.currentDate);
        this.innerWidth = window.innerWidth;
    };
    Object.defineProperty(RoomAllocationTableComponent.prototype, "hasResults", {
        get: function () {
            return this.allocationTable !== undefined && this.allocationTable.displayItems.length !== 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoomAllocationTableComponent.prototype, "mainClasses", {
        get: function () {
            return (this.class + ' ' + 'p-1').trim();
        },
        enumerable: true,
        configurable: true
    });
    RoomAllocationTableComponent.prototype.showBgLight = function (index) {
        return index % 2 === 0;
    };
    /**
    * Handel openRoomInfo callback of room-allocation-item
    *
    * @param {number} roomId
    * @memberof RoomAllocationComponent
    */
    RoomAllocationTableComponent.prototype.onOpenRoomInfo = function (roomId) {
        this.activeItemId = roomId;
        this.modalRoomInfo.openModal();
    };
    /**
    * Handel openRoomInfo callback of room-allocation-item
    *
    * @param {number} roomId
    * @memberof RoomAllocationComponent
    */
    RoomAllocationTableComponent.prototype.onOpenSchedule = function (info) {
        this.openSchedule.emit(info);
    };
    /**
    * Handle click on "create reservation"
    *
    * @memberof RoomAllocationComponent
    */
    RoomAllocationTableComponent.prototype.onCreateReservation = function (params) {
        // todo: set time according to form
        if (params.to === null) {
            params.to = new Date(params.from.getTime() + 1000 * 3600);
        }
        this.createReservation.emit(params);
    };
    /**
     * Handle click on day navigate buttons (<, >)
     *
     * @param {boolean} backwards
     * @memberof RoomAllocationTableComponent
     */
    RoomAllocationTableComponent.prototype.onClickNavigate = function (backwards) {
        this.navigateDate.emit(backwards);
    };
    Object.defineProperty(RoomAllocationTableComponent.prototype, "isMobileView", {
        /**
         * true if windows size is smaller or equal to 768px (Bootstrap's 'md' limit)
         *
         * @readonly
         * @type {boolean}
         * @memberof RoomAllocationTableComponent
         */
        get: function () {
            return this.innerWidth < 768;
        },
        enumerable: true,
        configurable: true
    });
    RoomAllocationTableComponent.prototype.InitClickeables = function () {
        var _this = this;
        if (!this.currentDate || !this._model) {
            return;
        }
        this.allocationTable = this._model;
        var startDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate());
        var endDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate(), 23, 59, 59, 999);
        this.allocationTable.displayItems.forEach(function (item) {
            var emptyItems = ScheduleItem.createEmptyScheduleItems(item.resourceId, item.scheduleItems, new Date(startDate), new Date(endDate), item.isBookable
                ? (!item.warning ? _this.translate.get('CLICK_TO_RESERVE') : _this.translate.get('CLICK_TO_REQUEST'))
                : _this.translate.get('NOT_BOOKABLE'), 
            // ! REVIEW: awaiting specific specification
            item.isBookingAllowed);
            item.scheduleItems = item.scheduleItems.concat(emptyItems);
        });
    };
    RoomAllocationTableComponent.prototype.alertConflict = function (timespan) {
        this.occupancyAlertModal.openModal();
    };
    return RoomAllocationTableComponent;
}());
export { RoomAllocationTableComponent };
